import { render, staticRenderFns } from "./WorkFloCard.vue?vue&type=template&id=525c92ab&scoped=true&"
import script from "./WorkFloCard.vue?vue&type=script&lang=js&"
export * from "./WorkFloCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkFloCard.vue?vue&type=style&index=0&id=525c92ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c92ab",
  null
  
)

export default component.exports